<script setup lang="ts">
const { attributeGroups } = defineProps<{
  attributeGroups: any
}>()
</script>

<template>
  <LazyUiDialog
    name="dimensions-and-details-dialog"
    dialog-type="responsive"
  >
    <template #dialogHeader>
      <span class="dialog__title">{{ $t('Dimensions and Details') }}</span>
    </template>

    <template
      v-for="(attributeGroup) in attributeGroups"
      :key="attributeGroup"
    >
      <table class="dimensions-and-details">
        <tbody>
          <tr
            v-for="spec in attributeGroup.attributes"
            :key="spec.code"
          >
            <th>{{ spec.label }}</th>
            <td v-html="spec.value" />
          </tr>
        </tbody>
      </table>
    </template>
  </LazyUiDialog>
</template>

<style>
@import url("~layers/components/Product/DimensionsAndDetailsDialog.css");
</style>
